import React from 'react';
import styled from 'styled-components';
import {Input} from 'components/antd';

type Props = {
  children?: React.ReactNode;
  name?: string;
  value?: string;
  placeholder?: string;
  autoSize?: {minRows: number};
  error?: boolean;
  onChange?: any;
  onBlur?: any;
};

export default ({error, children, ...props}: Props) => {
  return (
    <StyledInput error={error ? 1 : 0} {...props}>
      {children}
    </StyledInput>
  );
};

const StyledInput = styled(Input.TextArea)<{error: number}>`
  &&& {
    border-radius: 4px;
    border: ${(props) =>
      props.error ? '1px solid #EA3F60' : '1px solid #afc1fd'};

    &:focus {
      border: ${(props) =>
        props.error ? '1px solid #EA3F60' : '1px solid #3864fb'};
    }
  }
`;
